import { render, staticRenderFns } from "./TableWatermeters.vue?vue&type=template&id=05569d4f&"
import script from "./TableWatermeters.vue?vue&type=script&lang=js&"
export * from "./TableWatermeters.vue?vue&type=script&lang=js&"
import style0 from "./TableWatermeters.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
